import classNames from "classnames"

export function TughlaqGovernor({governor, level, leftSide}) {
    return (<div className={classNames("w-[70px] flex flex-row border-2 rounded-lg", leftSide ? 'leftSideBorderColor' : 'rightSideBorderColor')}>
        <div className="">
            <img className="w-[45px]" src={`/liveGameIcons/unique/tughlaq/${governor}.png`} alt=""/>
        </div>

        <div className="my-auto">
            <img className="w-[35px]" src={`/age_icons/age_${level}.png`} alt=""/>
        </div>
    </div>)
}